
import React, {
  useEffect,
  useState,
} from "react";
import * as Config  from "../../config";
/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
import {
  Box,
  Typography,
  useTheme,
  useMediaQuery,
  InputBase,
  Divider,
  Button,
} from "@mui/material";
/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
import FlexBetween from "../../components/FlexBetween";
import WidgetWrapper from "../../components/WidgetWrapper";
// import ForgeIcon from "../../components/ForgeIcon";
import ProgressCircleGradient from "../../components/ProgressCircleGradient";
// import PsychedelicImage from "../../components/PsychedelicImage";  // TODO: Could not get this to work. TRY AGAIN!
/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
import JsonDictGrid from "../../components/JsonDictGrid";
import UnderConstruction from "../../components/UnderConstruction";
/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */


const LifeWidget = () => {
  const picturePath = "stable-diff-icon-400x400.jpg";
  const defaultImage = "forge-flow-512x512.png";
  const theme = useTheme();
  const pal = theme.palette;
  const [isMobileMenuToggled, setIsMobileMenuToggled] = useState(false);  // TODO: Might not need this. See below.

  const [post, setPost] = useState("");
  const [state, setState] = useState('default'); // 'default', 'waiting', 'completed', 'error'
  const [result, setResult] = useState('');
  const [seed, setSeed] = useState('');
  const [executionTime, setExecutionTime] = useState('');
  const [delayTime, setDelayTime] = useState('');
  const [workerId, setWorkerId] = useState('');
  // old
  const [randImage, setRandImage] = useState('');
  // new
  const [initialPyFaceImage, setInitialPyFaceImage] = useState('');
  const [initialPyFaceGenes, setInitialPyFaceGenes] = useState('');
  const [initialPyFaceNurture, setInitialPyFaceNurture] = useState('');
  const [initialPyFaceCulture, setInitialPyFaceCulture] = useState('');

  const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  };


  const createBotFolk = async () => {
    try {

      setState('waiting');
      const response = await fetch(`${Config.fastApiUri}/pyface`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        }
      });

      // setState('waiting');

      const response_json = await response.json();
      console.log("RESPONSE from /pyface ---------------------------:");
      console.log(response_json);
      console.log("-----------------------------------:");

      // const response_object = JSON.parse(response_json)
      console.log("PyFace SVG image data URL ---------------------------:");
      console.log(response_json.svgimage);
      console.log("PyFace Bot Folk Individual Genes ---------------------------:");
      console.log(response_json.genes);
      console.log("-----------------------------------:");

      setInitialPyFaceImage(response_json.svgimage);
      setInitialPyFaceGenes(response_json.genes);
      setInitialPyFaceNurture(response_json.nurture);
      setInitialPyFaceCulture(response_json.culture);
      setState('default')

    } catch (error) {
      setState('error');
      console.error('Error getting default PyFace:', error);
    }
  };


  useEffect(() => {
    // const randIndex = Math.floor(Math.random() * defaultImages.length);
    // setRandImage(defaultImages[randIndex].img);


    setState('waiting');  // Just kind of threw this here. Technically we should set states even for loading
    // a default PyFace. What if that goes very slowly or fails? Should be like how we handle anything like this,
    // even if they -usually- happen very fast. It's an asynchronous backend call and so it needs good user feedback
    // and a good user experience even for atypical events (errors or delays etc.)
    //
    // NOTE: New PyFace stuff here used to be ASYNC, but I made it sync as I first put it inside UseEffect.
    // TODO: I need to research doing async stuff inside useEffect.

    const fetchInitialPyFace = async () => {
      try {
        const response = await fetch(`${Config.fastApiUri}/pyface`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          }
        });

        // setState('waiting');

        const response_json = await response.json();
        console.log("RESPONSE from /pyface ---------------------------:");
        console.log(response_json);
        console.log("-----------------------------------:");

        // const response_object = JSON.parse(response_json)
        console.log("PyFace SVG image data URL ---------------------------:");
        console.log(response_json.svgimage);
        console.log("PyFace Bot Folk Individual Genes ---------------------------:");
        console.log(response_json.genes);
        console.log("-----------------------------------:");

        setInitialPyFaceImage(response_json.svgimage);
        setInitialPyFaceGenes(response_json.genes);
        setInitialPyFaceNurture(response_json.nurture);
        setInitialPyFaceCulture(response_json.culture);
        setState('default')

      } catch (error) {
        setState('error');
        console.error('Error getting default PyFace:', error);
      }
    };
    fetchInitialPyFace();

    // console.log(randIndex);
    // console.log(randImage);
  }, []);


  const isNonMobileScreens = useMediaQuery("(min-width: 1000px)");


  const handleDream = async (dreamParams) => {
  // const handleDream = async (dreamMode) => {
    // const { dreamType, action, data } = dreamParams;  // Example of multiple params
    const { mode } = dreamParams;  // Params, just single in this case.
    const newFormData = {
      mode: mode,
    }
    // const newFormData = {
    //   mode: dreamMode,
    // }
    console.log(newFormData);
    setState('waiting');

    try {
      const response = await fetch(`${Config.fastApiUri}/start-dream`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newFormData),
      });

      // setState('waiting');

      const response_json = await response.json();
      console.log("RESPONSE from /start-dream ---------------------------:");
      console.log(response_json);
      console.log("-----------------------------------:");

      const jobId = response_json.id;
      // TODO: IMPORTANT: Check the existence and the validity of the id here.
      // TODO: IMPORTANT: Check the existence and the validity of the id here.
      await pollJobStatus(jobId);
    } catch (error) {
      setState('error');
      console.error('Error submitting job:', error);
    }
  };

  // TODO: This code is not needed in this widget, correct? Other stuff can go to then.
  const pollJobStatus = async (jobId) => {
    try {
      setState('waiting');
      let jobComplete = false;
      while (!jobComplete) {

        const response = await fetch(`${Config.fastApiUri}/job-status/${jobId}`, {
          method: "GET",
        });

        const response_json = await response.json();
        console.log("RESPONSE from /job-status ---------------------------:");
        console.log(response_json);
        console.log("-----------------------------------:");

        if (response_json.status === 'COMPLETED') {
          setState('completed');
          const imageBase64 = response_json.output[0].image;
          const seedInt = response_json.output[0].seed;
          const executionTimeInt = response_json.executionTime;
          const delayTimeInt = response_json.delayTime;
          const workerIdInt = response_json.workerId;
          setResult(imageBase64);
          setSeed(seedInt);
          setExecutionTime(executionTimeInt);
          setDelayTime(delayTimeInt);
          setWorkerId(workerIdInt);
          jobComplete = true;
        } else if (response_json.status === 'ERROR') {
          setState('error');
          console.error('Job encountered an error:', response_json.error);
          jobComplete = true;
        } else {
          await sleep(3000);
        }
      }
    } catch (error) {
      setState('error');
      console.error('Error polling job status:', error);
    }
  };


  const handleLinkClickExt = (extUrl) => {
    if (!isNonMobileScreens) {
      setIsMobileMenuToggled(false);  // TODO: Correctness of this for ext link is debatable. Address everywhere.
    }
    window.open(
      extUrl,
      '_blank'
    );
  };


  return (
    <WidgetWrapper>
      <Typography
        variant="mainlogo"
        fontWeight="bold"
        fontSize="32px"
        color={pal.warning.main}
        sx={{
          "&:hover": {
            cursor: "default",
          },
        }}
      >
        <span style={{ fontStyle: "italic" }}>Bot Folk Synthetic Life</span>
      </Typography>
      <Typography
        fontWeight="500"
        fontSize="0.9rem"
        fontStyle="italic"
        display="inline"
        sx={{ mb: "1.0rem" }}
      >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Evolving &nbsp;AI &nbsp;Bots &nbsp;with &nbsp;DNA
      </Typography>


      <Typography
        color={pal.neutral.main}
        fontWeight="500"
        variant="h6"
        sx={{ mt: "0.2rem", mb: "0.7rem" }}
      >
        Bot Folk are a synthetic life form, &nbsp;an abstract model of a species with many human-like characteristics.<br />
        The below SVG image is the current 'physical' representation of a Bot Folk individual.
      </Typography>
      <Typography
        color={pal.neutral.main}
        fontWeight="500"
        variant="h6"
        sx={{ mb: "0.7rem" }}
      >
        Bot Folk have DNA. &nbsp;&nbsp;Each 'gene' defines some aspect of appearance, behavior or other factor.
      </Typography>
      <Typography
        color={pal.neutral.main}
        fontWeight="500"
        variant="h6"
        sx={{ mb: "1.0rem" }}
      >
        Clicking the button below runs Python code in a FastAPI worker, generating new 'DNA' and a new SVG image.<br />
        Scroll down to learn more!
      </Typography>


      <Divider sx={{ margin: "1.25rem 0" }} color={pal.primary.main} />

      <FlexBetween>
        <Button
          fullWidth
          onClick={() => createBotFolk({mode: "daydream"})}
          // onClick={handleDream("daydream")}
          sx={{
              fontWeight: "bold",
              ml: "0.5rem",
              mr: "0.5rem",
              backgroundColor: pal.primary.main,
              color: pal.bg.lift,
              "&:hover": { color: pal.primary.main },
          }}
        >
          CREATE A NEW UNIQUE BOT FOLK INDIVIDUAL
        </Button>
      </FlexBetween>

      <Divider sx={{ margin: "1.25rem 0" }} color={pal.primary.main} />

      {(state === 'default' || state === 'completed') && (
        <FlexBetween>
          <img
            src={`${initialPyFaceImage}`} // Bot Life images is expected to be in SVG data URL format
            alt="Face of a Bot Folk Individual"
            style={{
              width: '400px',
              // height: '768px',
              // maxWidth: '100%',
              // maxHeight: '512px',
              borderRadius: "20px",
            }}
          />
          <Box>
            <Typography
              color={pal.neutral.main}
              fontWeight="700"
              variant="h5"
              sx={{ mt: "0.2rem", mb: "0.7rem" }}
            >
              {initialPyFaceCulture.cfnm} &nbsp;{initialPyFaceCulture.clnn}
            </Typography>
            <Typography
              color={pal.neutral.main}
              fontWeight="500"
              variant="h7"
              sx={{ mt: "0.2rem", mb: "0.7rem" }}
            >
              ID: &nbsp;{initialPyFaceCulture.cuid}<br />
              Born: &nbsp;{initialPyFaceCulture.cbir}<br />
              Gender: &nbsp;{initialPyFaceGenes.igen ? ('Female') : ('Male')}
            </Typography>
          </Box>
        </FlexBetween>
      )}

      {state === 'waiting' && (
        <Box width="400px">
          <FlexBetween>
            <ProgressCircleGradient />
            <ProgressCircleGradient />
            <ProgressCircleGradient />
            <ProgressCircleGradient />
            <ProgressCircleGradient />
          </FlexBetween>
          <br /><br />
          <FlexBetween>
            <ProgressCircleGradient />
            <ProgressCircleGradient />
            <ProgressCircleGradient />
            <ProgressCircleGradient />
            <ProgressCircleGradient />
          </FlexBetween>
          <br /><br />
          <FlexBetween>
            <ProgressCircleGradient />
            <ProgressCircleGradient />
            <ProgressCircleGradient />
            <ProgressCircleGradient />
            <ProgressCircleGradient />
          </FlexBetween>
          <br /><br />
          <FlexBetween>
            <ProgressCircleGradient />
            <ProgressCircleGradient />
            <ProgressCircleGradient />
            <ProgressCircleGradient />
            <ProgressCircleGradient />
          </FlexBetween>
          <br /><br />
          <FlexBetween>
            <ProgressCircleGradient />
            <ProgressCircleGradient />
            <ProgressCircleGradient />
            <ProgressCircleGradient />
            <ProgressCircleGradient />
          </FlexBetween>
        </Box>
      )}

      {state === 'error' && ("Something went wrong. Please try again.")}

      <Divider sx={{ margin: "1.25rem 0" }} color={pal.primary.main} />

      <Typography
        color={pal.neutral.main}
        fontWeight="500"
        variant="h5"
        sx={{ mb: "1.0rem" }}
      >
        At this early phase, the model is very simple. Three types of information define a Bot Folk individual:
      </Typography>
      <Typography
        color={pal.neutral.main}
        fontWeight="500"
        variant="h6"
        sx={{ mb: "1.2rem" }}
      >
        <strong>genes</strong> &nbsp;- &nbsp;Define the morphology and behavior encoded in the individual Bot at 'birth'. &nbsp;Determined during reproduction.<br />
        <strong>nurture</strong> &nbsp;- &nbsp;Characteristics created/influenced by all beings and all things in the Bot's environment as life progresses.<br />
        <strong>culture</strong> &nbsp;- &nbsp;Informational characteristics assigned/influenced by the culture and society of the Bot.
      </Typography>

      {state === 'completed' && (
        <Typography
          fontWeight="500"
          fontSize="0.75rem"
          sx={{
            color: pal.neutral.dark,
            mt: "0.07rem",
            mb: "0.05rem",
            mr: "0.7rem",
          }}
        >
          DNA: &nbsp;&nbsp;&nbsp;{initialPyFaceGenes}
        </Typography>
      )}

      {(state === 'default' || state === 'waiting') && (
        <FlexBetween gap={"1.2rem"}>
          <Box>
            <Typography
              fontWeight="600"
              fontSize="0.8rem"
              // fontStyle="italic"
              // display="inline"
              sx={{ mb: "0.4rem" }}
            >
              Genes &nbsp;(DNA)
            </Typography>
            <JsonDictGrid headone={'gene'} headtwo={'value'} data={initialPyFaceGenes}/>
          </Box>
          <Box>
            <Typography
              fontWeight="600"
              fontSize="0.8rem"
              // fontStyle="italic"
              // display="inline"
              sx={{ mb: "0.4rem" }}
            >
              Nurture &nbsp;(Environmental)
            </Typography>
            <JsonDictGrid headone={'factor'} headtwo={'value'} data={initialPyFaceNurture}/>
          </Box>
          <Box>
            <Typography
              fontWeight="600"
              fontSize="0.8rem"
              // fontStyle="italic"
              // display="inline"
              sx={{ mb: "0.4rem" }}
            >
              Culture &nbsp;(Societal)
            </Typography>
            <JsonDictGrid headone={'trait'} headtwo={'value'} data={initialPyFaceCulture}/>
          </Box>
        </FlexBetween>
      )}

      <Divider sx={{ margin: "1.25rem 0" }} color={pal.primary.main} />

      <Typography
        color={pal.neutral.main}
        fontWeight="500"
        variant="h5"
        sx={{ mb: "1.0rem" }}
      >
        The site at Botfolk.ai is a prototype, under-construction for this hobby project.<br />
        Explore an early form of a 3D Bot Folk world right in your web browser! &nbsp;<em>(&nbsp;Via the Three.js module.&nbsp;)</em><br /><br />
        Initially there will be two worlds, very different and with distinct Bot Folk populations:
      </Typography>
      <Typography
        color={pal.neutral.main}
        fontWeight="500"
        variant="h6"
        sx={{ mb: "0.5rem" }}
      >
        <strong>Botville</strong> &nbsp;- &nbsp;The Bot Folk village. The struggles and rewards are many. &nbsp;Like a human world.<br />
        <strong>Ultraspace</strong> &nbsp;- &nbsp;An unlimited and abstract, multi-dimensional space. &nbsp;Like a computer's dream.
      </Typography>
      <Typography
        variant="mainlogo"
        fontWeight="bold"
        fontSize="26px"
        // fontStyle="italic"
        color={pal.warning.main}
        onClick={() => handleLinkClickExt('https://botfolk.ai')}
        sx={{
          "&:hover": {
            color: pal.primary.less_ink,
            cursor: "pointer",
          },
        }}
      >
        BotFolk.ai
      </Typography>

      <UnderConstruction />

    {/*<PsychedelicImage imageUrl={`${Config.expressUri}/assets/img/forge-flow-512x512.png`}/>*/}

    </WidgetWrapper>
  );
};

export default LifeWidget;

